import { Input, Select } from 'semantic-ui-react';
import { formInput, formLabel, formSelectService } from '../../../../components/helpers';

export const TarjetahabienteInfo = (props) => {
  const {
    event,
    inputs,
    errorInputs,
    handleInputs,
    selectHandle,
    totalDonation,
    question = '¿La persona que asiste al evento es el mismo tarjetahabiente o titular de la cuenta bancaria?',
  } = props;

  if (event !== undefined || totalDonation !== undefined) {
    if (!(totalDonation > 0 || event?.['volunteerDonation'])) {
      return null;
    }
  }

  return (
    <div style={{ margin: '0 0 20px 0' }}>
      {formLabel('es_tarjetahabiente', question, errorInputs)}
      {formSelectService({
        Select,
        handler: selectHandle,
        label: question,
        name: 'es_tarjetahabiente',
        value: inputs.es_tarjetahabiente || '',
        errorInputs,
        options: ['Sí', 'No'],
      })}
      {inputs.es_tarjetahabiente === 'No' && (
        <>
          <div style={{ margin: '1rem 0 0 0' }}>
            {formLabel(
              'nombre_tarjetahabiente',
              'Nombre del tarjetahabiente o titular de la cuenta bancaria',
              errorInputs
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Nombre del tarjetahabiente o titular de la cuenta bancaria',
              name: 'nombre_tarjetahabiente',
              value: inputs.nombre_tarjetahabiente || '',
              errorInputs,
            })}
          </div>
          <div style={{ margin: '1rem 0 0 0' }}>
            {formLabel(
              'identificacion_tarjetahabiente',
              'Identificación del tarjetahabiente o titular de la cuenta bancaria',
              errorInputs
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Identificación del tarjetahabiente o titular de la cuenta bancaria',
              name: 'identificacion_tarjetahabiente',
              value: inputs.identificacion_tarjetahabiente || '',
              errorInputs,
              type: 'number',
            })}
          </div>
        </>
      )}
    </div>
  );
};
